import React from 'react';
import { Tag, Popover, Card } from 'antd';
import { EditFilled } from '@ant-design/icons';
import { SwatchesPicker } from 'react-color';
import useColorPicker from '../Hooks/useColorPicker';
import {v4 as uuidv4} from 'uuid';


const ColoredItem = ({ label, color, onUpdateColor }) => {

    const content = (
        <Card>
            <SwatchesPicker color={color} onChangeComplete={onUpdateColor} />
        </Card>
    );
    return (
        <Popover content={content}>
            <Tag
                icon={<EditFilled style={{ color: "#fff", fontSize: '16px' }} />}
                style={{
                    background: color,
                    fontSize: '13px',
                    color: "#fff",
                    textTransform: 'capitalize',
                    borderRadius: '25px',
                    padding: '3px 7px',
                    margin: '5px',
                    cursor: 'pointer'
                }}
            >
                {label}
            </Tag>
        </Popover>
    )
};

export default ColoredItem;
